import { Container, Element } from '@playcanvas/pcui';

class Spinner extends Container {
    setText: (value: string) => void;

    constructor(args = {}) {
        args = {
            ...args,
            id: 'spinner-container',
            hidden: true
        };

        super(args);

        this.dom.tabIndex = 0;
        this.dom.classList.add('blocks-shortcuts');

        const spinner = new Element({
            dom: 'div',
            class: 'spinner'
        });

        this.append(spinner);

        // Olloport: status line under the spinner (LOD build stage, upload …)
        const text = new Element({ dom: 'div', class: 'spinner-text', hidden: true });
        this.append(text);
        this.setText = (value: string) => {
            text.dom.textContent = value ?? '';
            text.hidden = !value;
        };

        this.dom.addEventListener('keydown', (event) => {
            if (this.hidden) return;
            event.stopPropagation();
            event.preventDefault();
        });
    }
}

export { Spinner };
